import React from 'react';
import { Check as Icon } from 'react-bootstrap-icons';
import { useController } from './provider';
import Button from 'react-bootstrap/Button';

export const ConfirmButton = () => {
    const { save, isEditing } = useController();
    return !isEditing ? null : (
        <Button variant="outline-primary" onClick={save}><Icon /></Button>
    );
};
